import React from "react";
import { useSelector } from "react-redux";

const YourOrders = () => {
  let carts = useSelector((state) => state.products.carts);

  const cartTotal = () => {
    return carts.reduce(function (total, item) {
      return total + (item.quantity || 1) * item.price;
    }, 0);
  };
  return (
    <>
      <div className="order_review  box-shadow bg-white">
        <div className="check-heading">
          <h3>Your Orders</h3>
        </div>
        <div className="table-responsive order_table">
          <table className="table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {carts.map((data) => (
                <tr>
                  <td>
                    {data.name}
                    <span className="product-qty">{data.quantity || 1}</span>
                  </td>
                  <td>
                   ₹{data.price} X ({data.quantity || 1}) ={" "}
                    {data.price * (data.quantity || 1)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th>SubTotal</th>
                <td className="product-subtotal">₹{cartTotal()}.00</td>
              </tr>
              <tr>
                <th>Shipping</th>
                <td>Free Shipping</td>
              </tr>
              <tr>
                <th>Total</th>
                <td className="product-subtotal">
                ₹{cartTotal() * 0.18 + cartTotal()}.00
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
};

export default YourOrders;
